import { render, staticRenderFns } from "./MyTabs.vue?vue&type=template&id=31a13f98&scoped=true&"
import script from "./MyTabs.vue?vue&type=script&lang=js&"
export * from "./MyTabs.vue?vue&type=script&lang=js&"
import style0 from "./MyTabs.vue?vue&type=style&index=0&id=31a13f98&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a13f98",
  null
  
)

export default component.exports